<template>
  <div class="exception-data">
    <template v-if="parsed">
      <div class="exception-data__summary">
        {{ $tt('异常记录：{p0} 条', { p0: parsed.units.length }) }} ·
        {{ $tt('设备还有后续数据：{p0}', { p0: $tt(parsed.hasMore ? '是' : '否') }) }}
      </div>
      <div v-if="!parsed.units.length">{{ $tt('设备没有异常数据') }}</div>
      <div class="exception-data__units">
        <div v-for="(unit, index) in parsed.units" :key="index" class="exception-data__unit">
          <strong>{{ index + 1 }}. {{ unit.code === 0xD5 ? '0xD5' : '0xD6' }} {{ $tt(unit.code === 0xD5 ? '电池电压异常' : '温度异常') }}</strong>
          <div>{{ $tt('发生时间（本地）') }}: {{ formatTime(unit.timestampSeconds) }}</div>
          <div class="exception-data__summary">{{ $tt('时间戳（秒）') }}: {{ unit.timestampSeconds }}</div>
          <template v-if="unit.code === 0xD5">
            <div v-for="(voltage, cell) in unit.cellVoltagesMv" :key="cell">
              {{ $tt('电芯 {p0}', { p0: cell + 1 }) }}: {{ voltage === null ? $tt('正常') : `${voltage} mV` }}
            </div>
          </template>
          <template v-else>
            <div>{{ $tt('充放电状态') }}: {{ stateText(unit.chargeDischargeState) }}</div>
            <div>{{ $tt('温度') }}: {{ unit.temperatureCelsius.toFixed(1) }} °C</div>
          </template>
        </div>
      </div>
    </template>
    <div v-else class="exception-data__error">{{ $tt('无法解析：数据为空、格式不完整或包含未知异常码，请核对原始数据。') }}</div>
    <details v-if="showRaw" class="exception-data__raw">
      <summary>{{ $tt('原始 0x2E 数据') }}</summary>
      <code>{{ rawData || '—' }}</code>
    </details>
  </div>
</template>

<script>
import moment from 'moment'
import { parsePowerBankException } from '@/utils/power-bank-exception'

export default {
  name: 'ExceptionData',
  props: {
    rawData: { type: String, default: '' },
    showRaw: { type: Boolean, default: true }
  },
  computed: {
    parsed () { return parsePowerBankException(this.rawData) }
  },
  methods: {
    formatTime (seconds) { return moment.unix(seconds).format('YYYY-MM-DD HH:mm:ss') },
    stateText (state) {
      const states = ['空闲', '充电', '放电']
      return `${this.$tt(states[state] || '未知')} (${state})`
    }
  }
}
</script>

<style scoped>
.exception-data {
  min-width: 280px;
  max-width: 520px;
  line-height: 1.6;
}
.exception-data__summary {
  color: #666;
  font-size: 12px;
}
.exception-data__units {
  max-height: 320px;
  overflow-y: auto;
}
.exception-data__unit + .exception-data__unit {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
}
.exception-data__error {
  color: #ad6800;
}
.exception-data__raw {
  margin-top: 8px;
}
.exception-data__raw summary {
  cursor: pointer;
  color: #666;
}
.exception-data__raw code {
  display: block;
  max-height: 160px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
